document.addEventListener("DOMContentLoaded", () => {
    const DELAY = 600;
    const img = document.querySelector(".onair__ttl-img");

    if (!img) return;

    setTimeout(() => {
        img.src = img.dataset.src;
    }, DELAY);
});